import { createContext, useContext } from 'react';

/**
 * Whether the portal's navigation sidebar is actually on screen for this route — the layout's own
 * `shouldShowSidebar`, published so a page can tell "collapsed" apart from "not rendered at all"
 * (the Chatwoot views, where `useSidebar()` still answers from the provider wrapping every route).
 */
export const PortalNavVisibleContext = createContext(false);

export const usePortalNavVisible = () => useContext(PortalNavVisibleContext);
